/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type app_v1_settings_UserSettings = {
    dark_mode?: boolean;
    overview_option?: app_v1_settings_UserSettings.overview_option;
    user_preferred_language?: app_v1_settings_UserSettings.user_preferred_language;
};

export namespace app_v1_settings_UserSettings {

    export enum overview_option {
        BASIC = 'basic',
        ADVANCED = 'advanced',
    }

    export enum user_preferred_language {
        EN = 'en',
        SV = 'sv',
    }


}

